import { PilotAssessmentCertificate } from '@/service'

function formatScore(score: number | string): string {
  const value = Number(score)
  return Number.isFinite(value) ? value.toFixed(1) : String(score)
}

export function downloadPilotAssessmentCertificate(
  certificate: PilotAssessmentCertificate,
): void {
  const canvas = document.createElement('canvas')
  canvas.width = 1400
  canvas.height = 900
  const context = canvas.getContext('2d')
  if (!context) return

  const gradient = context.createLinearGradient(0, 0, 1400, 900)
  gradient.addColorStop(0, '#ffffff')
  gradient.addColorStop(1, '#eaf3ff')
  context.fillStyle = gradient
  context.fillRect(0, 0, 1400, 900)
  context.strokeStyle = '#8bb7ed'
  context.lineWidth = 5
  context.strokeRect(35, 35, 1330, 830)
  context.strokeStyle = '#bdd6f5'
  context.lineWidth = 2
  context.strokeRect(60, 60, 1280, 780)
  context.textAlign = 'center'
  context.fillStyle = '#194c88'
  context.font = 'bold 54px Microsoft YaHei'
  context.fillText('专业技能证书', 700, 190)
  context.fillStyle = '#7892b2'
  context.font = '22px Arial'
  context.fillText('UAV PILOT PROFESSIONAL SKILL CERTIFICATE', 700, 235)
  context.fillStyle = '#173d70'
  context.font = 'bold 42px Microsoft YaHei'
  context.fillText('无人机飞手专业能力考评', 700, 360)
  context.fillStyle = '#506b90'
  context.font = '26px Microsoft YaHei'
  context.fillText(`已完成“${certificate.sessionName}”本轮全部启用考试科目`, 700, 450)
  context.fillText('各科目成绩及总分达到专业技能证书生成条件', 700, 498)
  context.font = '22px Microsoft YaHei'
  context.fillText(`证书编号：${certificate.certificateNo}`, 700, 585)
  context.fillText(
    `第 ${certificate.roundNo} 次考试 · 总分 ${formatScore(certificate.totalScore)}`,
    700,
    650,
  )
  context.fillText(certificate.completedDate, 700, 700)
  context.font = '18px Microsoft YaHei'
  context.fillStyle = '#7892b2'
  context.fillText(`生成时间：${certificate.generatedAt}`, 700, 760)

  const link = document.createElement('a')
  link.download = `专业技能证书_${certificate.sessionName}_第${certificate.roundNo}次考试.png`
  link.href = canvas.toDataURL('image/png')
  link.click()
}
